require('./accountsProductCMSBanners.scss');

// @vendors
const React = require('react');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const PropTypes = require('prop-types');
const uniq = require('lodash/array/uniq');
const { connect } = require('react-redux');
// @helpers
const { nonNumericFilter } = require('utilities/stringHelper');
//@components
const InterestsExample = require('components/interestsExample/interestsExample');
const ProductBanner = require('components/commons/productBanner/productBanner');
const { LoadingSection } = require('commonsComponents/loadingSection');
const RiskProduct = require('components/riskProduct/riskProduct');
const AccountBlockedErrorModal = require('components/accounts/accountBlockedErrorModal/accountBlockedErrorModal');
// @actions
const hiringProductBannersActions = require('actions/hiringProductBanners');
//@commons
const { OKButton } = require('components/commons/OKButton/OKButton');
//@core
const { FormattedText, formatText }= require('core/i18n').i18n;
// @constants
const {
    CURRENT_ACCOUNT_PRODUCT_ALIAS,
    OPEN_YOUNG_ACCOUNT_PRODUCT_ALIAS,
    OPEN_YOUNG_PACK_PRODUCT_ALIAS,
    PAYROLL_ACCOUNT_ALIAS,
    SAVING_ACCOUNT_ALIAS,
} = require('constants/hiringProductInformation');
//@constants
const { PROC_PACK_OPEN_YOUNG, PROC_CONTRACTS } = require('utilities/tagging');
const {
    NOT_ALLOWED_CHECKING_URLS_COUNTRIES,
    NOT_ALLOWED_PAYROLL_URLS_COUNTRIES,
    OPEN_YOUNG,
} = require('constants/flagBasedFeatures.js');
// @hocs
import withFeatureToggling from 'hocs/withFeatureToggling/withFeatureToggling';

class AccountsProductCMSBanners extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showMore: false
        };

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.getUserOwnedProductBannersCode = this.getUserOwnedProductBannersCode.bind(this);
        this.handleShowMoreClick = this.handleShowMoreClick.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    componentDidMount() {
        const {
            getHiringProductBanners,
            immFlagBasedFeatures,
            isNerudaUser,
            originCountry,
        } = this.props;
        
        let requestedProducts;

        if (isNerudaUser){
            requestedProducts = [
                {
                    alias: CURRENT_ACCOUNT_PRODUCT_ALIAS
                },{
                    alias: PAYROLL_ACCOUNT_ALIAS
                }
            ];
        }else{
            requestedProducts = [
                {
                    alias: PAYROLL_ACCOUNT_ALIAS
                },{
                    alias: SAVING_ACCOUNT_ALIAS
                },{
                    alias: OPEN_YOUNG_ACCOUNT_PRODUCT_ALIAS
                },{
                    alias: OPEN_YOUNG_PACK_PRODUCT_ALIAS
                },{
                    alias: CURRENT_ACCOUNT_PRODUCT_ALIAS
                }
            ];
        }
        
        if (!immFlagBasedFeatures.get(OPEN_YOUNG)) {
            const packOpenYoungIndex = requestedProducts.findIndex(product => product.alias === OPEN_YOUNG_PACK_PRODUCT_ALIAS);
            requestedProducts.splice(packOpenYoungIndex, 1);
        }

        if (!!immFlagBasedFeatures.get(NOT_ALLOWED_CHECKING_URLS_COUNTRIES).find(country => country === originCountry)) {
            const checkingAccountIndex = requestedProducts.findIndex(product => product.alias === CURRENT_ACCOUNT_PRODUCT_ALIAS);
            requestedProducts.splice(checkingAccountIndex, 1);
        }

        if (!!immFlagBasedFeatures.get(NOT_ALLOWED_PAYROLL_URLS_COUNTRIES).find(country => country === originCountry)) {
            const payrollAccountIndex = requestedProducts.findIndex(product => product.alias === PAYROLL_ACCOUNT_ALIAS);
            requestedProducts.splice(payrollAccountIndex, 1);
        }

        getHiringProductBanners(requestedProducts);
    }

    closeModal() {
        this.props.showAccountBlockedErrorModal(false);
    }

    getProductBannersOrder(userCardsAdvertisementTypes, immBannerOrder) {  
        const accountTypesContractedByUser = [];
        const accountTypesNonContractedByUser = [];

        /** OPE019-2292 - 
         * (Client contracted, corresponding wafers will go last) 
            300. <any subtype> are the current accounts -> Serious for Open Account 
            300.805 - -> Current Account Payroll 
            301. <any subtype> is a savings account -> Serious for Openbank 
            301.101 -> OpenYoung / Junior savings account
         */
        immBannerOrder.forEach(immBanner => {
            const product = immBanner.get('type');
            const subproduct = immBanner.get('subType');
            const accountType = nonNumericFilter(product + subproduct);

            if (userCardsAdvertisementTypes.includes(accountType)) {
                accountTypesContractedByUser.push(accountType);
            } else if((accountType !== '301101' && accountType !== '300805') 
                && userCardsAdvertisementTypes.includes(product)) {
                accountTypesContractedByUser.push(accountType);
            }
            else {
                accountTypesNonContractedByUser.push(accountType);
            }
        });

        return accountTypesNonContractedByUser.concat(accountTypesContractedByUser);
    }

    getUserOwnedProductBannersCode() {
        const output = [];
        
        this.props.immAccounts.get('byId').forEach(immAccount => {
            const product = immAccount.get('newProduct');
            const subproduct = immAccount.get('accountType');

            if (product !== '100') { // immAccount isn't a "credito de inversion".
                const accountCodeType = nonNumericFilter(product + subproduct);
                if (accountCodeType === '300805' || accountCodeType === '301101') {
                    output.push(accountCodeType);
                } else {
                    output.push(product);
                }
            }

        });

        return uniq(output);
    }

    buildShowMoreButton(bannerOrder) {
        if (bannerOrder.length > this.props.limit && !this.state.showMore) {
            const accountText = formatText('accounts-accounts');
            return (
                <div className="accounts-product-banners__show-more-button">
                    <OKButton modifier="secondary" inverse={true} onClick={this.handleShowMoreClick}>
                        <FormattedText value="productBanner-seeMore" injectedStrings={[accountText]} />
                    </OKButton>
                </div>
            )
        }
    }

    handleShowMoreClick() {
        this.setState({
            showMore: true
        });
    }

    buildProductBanners = (orderedProductBanners, immBanners) => {
        const { limit, flagBasedFeatures } = this.props;

        return orderedProductBanners.map((bannerKey, index) => {
            const immBanner = immBanners.find(banner => banner.get('codeType') === bannerKey);
            
            const alias = immBanner.get('alias');
            const title = immBanner.get('title');
            const subtitle = immBanner.get('subtitle');
            const immAdvantages = immBanner.get('advantages');
            const link = immBanner.get('link');
            const sidebarImgUrl = immBanner.get('sidebarImgUrl');
            const featureTogglingKey = immBanner.get('featureTogglingKey');
            let processType, eventName, eventTag;
            let advantages = [];
            
            //Parse advantages
            if (immAdvantages) {
                advantages = immAdvantages.toJS();
            }

            //Parse image details
            const immSidebarImgDetails = immBanner.get('sidebarImageDetails');
            const sidebarImgAlt = immSidebarImgDetails.get('sidebarImgAlt');
            
            if (alias === OPEN_YOUNG_PACK_PRODUCT_ALIAS) {
                processType = PROC_PACK_OPEN_YOUNG;
            }
            /* This is only added to Cuenta Nomina, because of the intermediate screen
            to decide if you want to hire a new account or update an actual Cuenta Corriente */
            if (alias === PAYROLL_ACCOUNT_ALIAS) {
                processType = PROC_CONTRACTS;
                eventName = 'pre-inicio';
                eventTag = 'CUENTA NÓMINA OPEN';
            }

            if ((featureTogglingKey && flagBasedFeatures.get(featureTogglingKey) || !featureTogglingKey) && (index < limit || this.state.showMore)) {
                return (
                    <ProductBanner
                        id={alias}
                        key={`product-cms-banners-${index}`}
                        advantages={advantages}
                        link={link}
                        subtitle={subtitle}
                        title={title}
                        processType={processType}
                        eventName={eventName}
                        eventTag={eventTag}
                        sidebarImgAlt={sidebarImgAlt}
                        sidebarImgUrl={sidebarImgUrl}
                        isAccountHiringFlow
                        linkText="productBanner-productBanner_accountsButton"
                    />
                );
            }
            else {
                return null;
            }
        });
    }

    render() {
        const {
            immFlagBasedFeatures, 
            immHiringProductBanners,
            isNerudaUser,
        } = this.props;
        const immProductBanners = immHiringProductBanners.get('productBanners') || [];
        const userOwnedProductBannersCode = this.getUserOwnedProductBannersCode();
        const orderedProductBanners = this.getProductBannersOrder(userOwnedProductBannersCode, immProductBanners);
        const banners = this.buildProductBanners(orderedProductBanners, immProductBanners);
        const showMoreButton = this.buildShowMoreButton(orderedProductBanners);
        let interestsExample = null;
        let accountsBanners;
        const showErrorModal = immHiringProductBanners.get("showErrorModal");
        let accountBlockedErrorModal = (
            <AccountBlockedErrorModal 
                description={<FormattedText value="accountBlockedErrorModal-errorDescription" />}
                handleSubmit={this.closeModal}
                showModal={showErrorModal}
                title={formatText('accountBlockedErrorModal-errorTitle')}
            />
        )

        if (!isNerudaUser){
            interestsExample = <InterestsExample keyText={'productBanner-productBanner_accountsInterestsExample'} />;
        }

        if (immHiringProductBanners.get('isFetching') ) {
            accountsBanners = <LoadingSection />
        } else {
            accountsBanners = (
                <section className="accounts-product-cms-banners">
                    <header className="accounts-product-cms-banners__header">
                        <FormattedText value="productBanner-meetAccounts" />
                    </header>
                    <RiskProduct
                        immFlagBasedFeatures={immFlagBasedFeatures}
                        indicatorText={formatText('riskProduct-riskProduct_indicatorAccountsText')}
                    />
                    {banners}
                    {accountBlockedErrorModal}
                    {showMoreButton}
                    {interestsExample}
                </section>
            );
        }

        return accountsBanners;
    }
}

AccountsProductCMSBanners.propTypes = {
    flagBasedFeatures: PropTypes.object.isRequired,
    getHiringProductBanners: PropTypes.func,
    immAccounts: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immHiringProductBanners: PropTypes.object.isRequired,
    isNerudaUser: PropTypes.bool,
    limit: PropTypes.number,
    originCountry: PropTypes.string.isRequired,
    showAccountBlockedErrorModal: PropTypes.func
};

AccountsProductCMSBanners.defaultProps = {
    limit: 10
}

module.exports = connect(
    state => ({
        immAccounts: state.accounts,
        immFlagBasedFeatures: state.flagBasedFeatures,
        immHiringProductBanners: state.hiringProductBanners,
        isNerudaUser: state.profile.get('isNerudaUser'),
        originCountry: state.profile.get('originCountry'),
    }),{
        getHiringProductBanners: hiringProductBannersActions.getHiringProductBanners,
        showAccountBlockedErrorModal: hiringProductBannersActions.showAccountBlockedErrorModal
    }
)(withFeatureToggling(AccountsProductCMSBanners));
